import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { Response } from '../../../../_shared/models';
import { CreateInsuranceClaimRequest } from '../models/insurance-request.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {
  private readonly baseUrl = `${environment.apiEndpoint}/InsuranceClaims/insurance-claims`;

  constructor(private httpClient: HttpClient) { }

  async createInsuranceClaim(request: CreateInsuranceClaimRequest, cancellation: Subject<void>): Promise<Response<void>> {
    return firstValueFrom(
      this.httpClient.post<Response<void>>(
        `${this.baseUrl}/create`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }
}
